const DAY_MS = 86_400_000;

function timestamp(value: unknown): number {
  return typeof value === 'string' && value.trim() ? Date.parse(value) : Number.NaN;
}

function elapsedDays(start: number, end: number): string | null {
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return null;
  return `${Math.floor((end - start) / DAY_MS)}d`;
}

// Dias corridos completos. Comentários e edições não reiniciam os relógios.
export function formatCardTime(card: Record<string, unknown>, now = Date.now()): string {
  const createdAt = timestamp(card.created_at);
  const phaseStartedAt = timestamp(card.data_entrada_coluna);
  const phaseName = String(card.fase_nome || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  const completed =
    phaseName === 'concluido' ||
    (card.tipo_processo === 'triagem_credito' && phaseName === 'encaminhado');
  const closed =
    completed || phaseName === 'perdido' || phaseName === 'cancelado' || phaseName === 'arquivado';
  const endAt = closed ? phaseStartedAt : now;
  const total = elapsedDays(createdAt, endAt);

  if (closed) return total ? `${total} total` : 'prazo indisponível';

  const phase = elapsedDays(phaseStartedAt, now);
  if (!phase || !total) return 'prazo indisponível';
  return `${phase} fase | ${total} total`;
}
